import { service } from '../redux/api/axios';

const fileUploadHandler = async (selectedFile) => {
  const data = new FormData();
  data.append('file', selectedFile);
  const response =
    selectedFile !== '' && (await service.post(`/file-upload`, data, {}));
  return selectedFile !== '' && response.data.secure_url;
};

export default fileUploadHandler;
